<template>
  <a-modal
    title="数据库设置"
    :width="600"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @cancel="handleCancel"
  >
    <a-spin :spinning="confirmLoading || pullLoading">
      <a-form :form="form">
        <a-form-item label="机器人子账户" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="['id', { initialValue: currentRobotId }]" read-only/>
        </a-form-item>
        <a-form-item label="数据库主机" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input-password
            :visibilityToggle="false"
            v-decorator="['database_host', {rules: [{required: true, message: '必填项'}]}]"
            placeholder="请填写"
          />
        </a-form-item>
        <a-form-item label="数据库端口" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input-password
            :visibilityToggle="false"
            v-decorator="['database_port', {rules: [{required: true, message: '必填项'}]}]"
            placeholder="请填写"
          />
        </a-form-item>
        <a-form-item label="数据库名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input
            v-decorator="['database_name', {rules: [{required: true, message: '必填项'}]}]"
            placeholder="请填写"
          />
        </a-form-item>
        <a-form-item label="数据库用户名" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input-password
            :visibilityToggle="false"
            v-decorator="['database_username', {rules: [{required: true, message: '必填项'}]}]"
            placeholder="请填写"
          />
        </a-form-item>
        <a-form-item label="数据库密码" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input-password
            :visibilityToggle="false"
            v-decorator="['database_password', {rules: [{required: true, message: '必填项'}]}]"
            placeholder="请填写"
          />
        </a-form-item>
      </a-form>
    </a-spin>
    <template slot="footer">
      <a-button @click="handleCancel">取消</a-button>
      <a-button :loading="confirmLoading" type="primary" @click="handleSubmit">确定</a-button>
    </template>
  </a-modal>
</template>

<script>
import DeviceApi from '@/api/device'
export default {
  data() {
    return {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 7 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 13 }
      },
      mdl: {},
      currentRobotId: '',
      visible: false,
      confirmLoading: false,
      pullLoading: false,
      form: this.$form.createForm(this)
    }
  },
  methods: {
    show(currentRobotId) {
      this.form.resetFields()
      this.currentRobotId = currentRobotId
      this.visible = true
      this.getData()
    },
    getData() {
      this.pullLoading = true
      DeviceApi.getDatabaseInfo({ sub_id: this.currentRobotId })
        .then(res => {
          if (res.code === 1) {
            this.form.setFieldsValue({
              database_password: res.data['database_password'],
              database_host: res.data['database_host'],
              database_name: res.data['database_name'],
              database_port: res.data['database_port'],
              database_username: res.data['database_username']
            })
          } else {
            this.$message.error(res.msg)
          }
        })
        .finally(() => {
          this.pullLoading = false
        })
    },
    handleCancel() {
      this.visible = false
    },
    handleSubmit(e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          this.confirmLoading = true
            DeviceApi.saveDatabaseInfo({
              sub_id:values.id,
              database_password: values.database_password,
              database_host: values.database_host,
              database_name: values.database_name,
              database_port: values.database_port,
              database_username: values.database_username,
            })
            .then((res) => {
              if (res.code === 1) {
                this.form.resetFields()
                this.$message.success("修改数据库信息成功");
                this.visible = false
                this.$emit('ok')
              } else {
                this.$message.error(res.msg);
              }
            }).finally(() => {
              this.confirmLoading = false
            })
        }
      })
    }
  }
}
</script>
